/* eslint-disable @typescript-eslint/no-unused-vars */
'use client'
import * as X from "@/ui";

import Mission1Image from "@/assets/about-us-mission-1.svg";
import Mission2Image from "@/assets/about-us-mission-2.svg";
import { useAboutUsPage } from "@/providers/strapi/content/types/singleTypes/about-us-page";
import ReactMarkdown from "react-markdown";


export function MissionSection(_props: X.PageProps) {
  // const tr = X.useTranslator();

  const missionCard = useAboutUsPage('missionCard');
  return (
    <section id="mission" className={X.clsx("scroll-mt-[120px] relative mt-0 my-10 xl:my-20")}>
      <h2 className="text-[35px] xl:text-[48px] [&_strong]:font-medium xl:text-center xl:max-w-content mx-mobile-margin xl:mx-auto mb-8 xl:mb-14 leading-tight">
        {/* {tr({
          en: <>Our mission is <strong>twofold</strong></>,
          fr: <>Notre mission <strong>est double</strong></>,
        })} */}
        <ReactMarkdown>
          {missionCard.title}
        </ReactMarkdown>
      </h2>

      <div className="xl:max-w-6xl xl:mx-auto flex flex-row relative">
        <div className={X.clsx(
          "bg-surface-purple w-[55%] xl:w-[60%] xl:py-10 xl:px-16",
          "p-mobile-margin pr-[20%] xl:pr-[180px]",
          "rounded-r-4xl xl:rounded-l-4xl flex flex-col gap-4"
        )}>
          <X.Image src={Mission1Image} alt="Mission 1" className="" />
          <ReactMarkdown components={{
            p: ({ ...props }) => <p {...props} className="text-[20px] xl:text-[22px] [&_strong]:font-bold leading-tight" />,
          }}>
            {missionCard.traveler}
          </ReactMarkdown>
          {/* <p className="text-[20px] xl:text-[22px] [&_strong]:font-bold leading-tight">
            {tr({
              en: <>For travelers: <strong>simplify</strong> VAT refunds, <strong>free</strong> the shopping experience</>,
              fr: <>Pour le voyageur{X.Nbsp}: <strong>simplifier</strong> la détaxe, <strong>libérer</strong> le shopping</>,
            })}
          </p> */}
        </div>
        <div className={X.clsx(
          "bg-white absolute w-[55%] xl:w-[50%] top-10 right-0 xl:py-10 xl:px-16 xl:translate-x-[20px]",
          "p-mobile-margin",
          "rounded-l-4xl xl:rounded-r-4xl flex flex-col gap-4",
        )}>
          <X.Image src={Mission2Image} alt="Mission 2" className="" />
          <ReactMarkdown components={{
            p: ({ ...props }) => <p {...props} className=" text-[20px] xl:text-[22px] [&_strong]:font-bold leading-tight" />,
          }}>
            {missionCard.retailer}
          </ReactMarkdown>
          {/* <p className={X.clsx(X.mobileOnly(), "text-[20px] xl:text-[22px] [&_strong]:font-bold leading-tight")}>
            {tr({
              en: <>For retailers: <strong>less</strong> paperwork, <strong>more freedom</strong> and <strong>time</strong></>,
              fr: <>Pour le commerçant{X.Nbsp}: <strong>moins</strong> de paperasse, <strong>plus de liberté</strong> et <strong>de temps</strong></>,
            })}
          </p>
          <p className={X.clsx(X.desktopOnly("block"), "text-[20px] xl:text-[22px] [&_strong]:font-bold leading-tight")}>
            {tr({
              en: <>For retailers: <strong>less</strong> paperwork, <strong>more freedom</strong> and <strong>time</strong></>,
              fr: <>Pour le commerçant{X.Nbsp}: <strong>moins</strong> de<br />paperasse, <strong>plus de liberté</strong> et <strong>de temps</strong></>,
            })}
          </p> */}
        </div>
      </div>

    </section>
  );
}
